import ModelPage from '@/pages/ModelPage.vue'

export default [
  {
    path: '/',
    name: 'model',
    component: ModelPage
  },

  {
    path: '/thank-you',
    name: 'thank-you',
    component: () => import(/* webpackChunkName: "thank-you" */ '@/pages/ThankYouPage.vue')
  },

  {
    path: '/policy',
    name: 'pocily',
    component: () => import(/* webpackChunkName: "policy" */ '@/pages/PolicyPage.vue')
  },

  {
    path: '/marketing',
    name: 'marketing',
    component: () => import(/* webpackChunkName: "policy" */ '@/pages/MarketingPage.vue')
  },

  {
    path: '/not-found',
    name: 'not-found',
    component: () => import(/* webpackChunkName: "not-found" */ '@/pages/NotFoundPage.vue')
  },

  {
    path: '/:model',
    name: 'modification',
    component: () => import(/* webpackChunkName: "modification" */ '@/pages/ModificationPage.vue')
  },

  {
    path: '/:model/:modification',
    name: 'tech-map',
    component: () => import(/* webpackChunkName: "tech-map" */ '@/pages/TechMapPage.vue')
  },

  {
    path: '/:model/:modification/service-request',
    name: 'service-request',
    component: () => import(/* webpackChunkName: "service-request" */ '@/pages/ServiceRequestPage.vue')
  },

  {
    path: '*',
    redirect: '/not-found'
  }
]
